module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Baden_AG-09018ece878ed35f802cd45427c14698.svg";